<template>
  <div id="championship" @scroll="getHeight">
    <div class="title">
      <img class="title1" src="@/assets/img/taiko/world/w_bg.png" alt="" />

    </div>
    <div class="content">
      <div class="world_tab">
        <div class="world_logo">
          <img src="@/assets/img/taiko/world/tab_logo.png" alt="" />
        </div>
        <div class="world_handle">
          <!-- <img v-if="page === 1" class="world_item"  src="@/assets/img/taiko/world/tab_1_active.png" />
          <img v-else @click="() => { this.page = 1 }" class="world_item" 
            src="@/assets/img/taiko/world/tab_1.png" /> -->
          <img v-if="page === 2" class="world_item" src="@/assets/img/taiko/world/tab_2_active.png" />
          <img v-else @click="() => { this.page = 2 }" class="world_item" src="@/assets/img/taiko/world/tab_2.png" />
          <img v-if="page === 3" class="world_item" src="@/assets/img/taiko/world/tab_3_active.png" />
          <img v-else @click="() => { this.page = 3 }" class="world_item" src="@/assets/img/taiko/world/tab_3.png" />
          <img v-if="page === 4" class="world_item" src="@/assets/img/taiko/world/tab_4_active.png" />
          <img v-else @click="() => { this.page = 4 }" class="world_item" src="@/assets/img/taiko/world/tab_4.png" />
        </div>
      </div>
      <div class="content_main" v-if="page === 1 || page === 2">
        <!-- <div class="block">
          <div class="content_1">
            <div class="content_bg">
              <img class="content_calenddar_img" src="@/assets/img/taiko/world/game_calendar.png" alt="">
            </div>
          </div>
        </div> -->
        <div class="block">
          <div class="stars"></div>
          <div class="content_1 content_2 ">
            <div class="content_bg">
              <img class="content_calenddar_img" src="@/assets/img/taiko/world/game_calendar.png" alt="">
            </div>
            <div class="content_bg">
              <img class="intro_title" height="28" src="@/assets/img/taiko/world/intro_title_1.png" alt="">
              <div class="intro_subtitle">
                <span>比赛时间</span>
                <span class="dotted_line"></span>
              </div>
              <div class="intro_content">2024年3月 具体日期以每个店铺公布的时间为准</div>

              <div class="intro_subtitle">
                <span>参赛方式</span>
                <span class="dotted_line"></span>
              </div>
              <div class="intro_content">比赛当天于店铺进行报名</div>

              <div class="intro_subtitle">
                <span>参赛资格</span>
                <span class="dotted_line"></span>
              </div>
              <div class="intro_content">
                <div>· 报名玩家需持有中华人民共和国居民身份证，港澳台居民可凭居住证参与本区域的店铺预选赛。</div>
                <div>· 已获得区域赛参赛凭证的“店铺代表”不可再次参与。</div>
                <div>· 未成年人参赛须由法定代理人或监护人同意方可参加。</div>
              </div>

              <div class="intro_subtitle">
                <span>参赛人数</span>
                <span class="dotted_line"></span>
              </div>
              <div class="intro_content">每个店铺20人（超过规定人数视店家改为抽选或增加人数上限）</div>

              <div class="intro_subtitle">
                <span>参赛费用</span>
                <span class="dotted_line"></span>
              </div>
              <div class="intro_content">以每个店铺公布信息为准</div>

              <div class="intro_subtitle">
                <span>比赛规则</span>
                <span class="dotted_line"></span>
              </div>
              <div class="intro_content">
                <div>· 根据报名顺序，每次由两名玩家游玩店铺预选赛用的三首课题曲其中一首，该歌曲的分数将作为本次店铺预选赛的成绩。 </div>
                <div>· 每组玩家游玩前需进行猜拳，由获胜者选择游玩1P或2P（左右方）。 </div>
                <div>· 所有玩家游玩过后，成绩较高的前两名将作为“店铺代表”获得「区域赛」参赛资格。 </div>
                <div>· 比赛课题曲将由每个店家于当天在现场发表。 </div>
              </div>

              <div class="intro_subtitle">
                <span>比赛奖励</span>
                <span class="dotted_line"></span>
              </div>
              <div class="intro_content">
                <div>每个店铺前2名可获得<span style="color: #6fb3f9;">“赛事专属奖状”</span>和 <span
                    style="color: #6fb3f9;">“区域赛参赛凭证”</span></div>
              </div>

              <div class="intro_subtitle">
                <span>特别说明</span>
                <span class="dotted_line"></span>
              </div>
              <div class="intro_content">
                <div>· 获得「区域赛」参赛资格的玩家需填写“预选赛代表表单”，未成年玩家需另外请法定代理人或监护人填写”同意书“并签名。 </div>
                <div>· 店铺预选赛结束后，请于七天内将表单交回参赛店铺。若未提交表单，将失去区域赛的参赛资格。 </div>
              </div>

              <div class="intro_subtitle">
                <span style="width: 50px;">课题曲</span>
                <span class="dotted_line"></span>
              </div>
              <div class="intro_content">
                <div>· 南梦宫原创音乐<br />「Hello, Worldooon!! / Capchii feat. Kuroa*」</div>
                <div>· 南梦宫原创音乐<br />「Aloft in the wind / Qutabire」</div>
                <div>· 南梦宫原创音乐<br />「Emma / BlackY feat. Risa Yuzuki」</div>
              </div>

            </div>
            <div class="content_bg">
              <img class="intro_title" height="28" src="@/assets/img/taiko/world/intro_title_2.png" alt="">

              <div class="intro_subtitle">
                <span>比赛时间</span>
                <span class="dotted_line"></span>
              </div>
              <div class="intro_content">2024年4月 具体日期以每个店铺公布的时间为准</div>

              <div class="intro_subtitle">
                <span>参赛资格</span>
                <span class="dotted_line"></span>
              </div>
              <div class="intro_content">
                <div>持有所在区域的“区域赛参赛凭证“的玩家</div>
                <div>未成年人参赛须由法定代理人或监护人同意方可参加</div>
              </div>

              <div class="intro_subtitle">
                <span>参赛费用</span>
                <span class="dotted_line"></span>
              </div>
              <div class="intro_content">
                <div>免费</div>
              </div>

              <div class="intro_subtitle">
                <span>比赛规则</span>
                <span class="dotted_line"></span>
              </div>
              <div class="intro_content">
                <div>比赛将会分为预赛阶段和决赛阶段进行</div>
                <div>
                  <div style="color: #eb4a36;margin:10px 0">①预赛阶段</div>
                  <div style="margin: 6px 10px;">· 玩家将通过抽签决定顺序，每次由两名玩家游玩三首预赛阶段课题曲中的其中两首，由两首歌曲的合计分数作为预赛成绩</div>
                  <div style="margin: 6px 10px;">· 每组玩家游玩前需进行猜拳，由获胜者选择游玩1P或2P（左右方）</div>
                  <div style="margin: 6px 10px;">· 第一首歌曲与第二首歌曲的1P、2P（左右方）将会互换</div>
                  <div style="margin: 6px 10px;">· 所有玩家游玩过后，成绩较高的前四名将晋级决赛阶段</div>
                  <div style="margin: 6px 10px;">· 比赛课题曲将由每个店家于当天在现场发表</div>
                </div>
                <div>
                  <div style="color: #eb4a36;margin:10px 0">②决赛阶段</div>
                  <div style="margin: 6px 10px;">· 玩家按照预选阶段的游玩顺序，每次由一名玩家游玩三首决赛阶段课题曲中的其中两首，由两首歌曲的合计分数作为决赛成绩</div>
                  <div style="margin: 6px 10px;">· 玩家可自由选择游玩的1P或2P（左右方）</div>
                  <div style="margin: 6px 10px;">· 四名玩家游玩过后，成绩最高者为本次区域赛冠军，获得“世界赛资格挑战”名额</div>
                  <div style="margin: 6px 10px;">· 比赛课题曲将由每个店家于当天在现场发表</div>
                </div>
              </div>

              <div class="intro_subtitle">
                <span>比赛奖励</span>
                <span class="dotted_line"></span>
              </div>
              <div class="intro_content">
                <div>冠军将获得 <span style="color: #6fb3f9;">“赛事特别纪念品”</span></div>
              </div>

              <div class="intro_subtitle">
                <span style="width: 78px;">预赛课题曲</span>
                <span class="dotted_line"></span>
              </div>
              <div class="intro_content">
                <div>· 南梦宫原创音乐<br />「Sapphire On Fire / 庭师」</div>
                <div>· 南梦宫原创音乐<br />「the telescope in virtual reality / deli.」</div>
                <div>· 南梦宫原创音乐<br />「punk bastards / Sobrem」</div>
              </div>

              <div class="intro_subtitle">
                <span style="width: 78px;">决赛课题曲</span>
                <span class="dotted_line"></span>
              </div>
              <div class="intro_content">
                <div>· 南梦宫原创音乐<br />「The Nue and Morning Stars / Silentroom」</div>
                <div>· 南梦宫原创音乐<br />「Unlimited Games / Ponchi♪ feat. haxchi」</div>
                <div>· 南梦宫原创音乐<br />「Hello, Mr.JOKER / D-D-Dice」</div>
              </div>

            </div>
            <div class="content_bg">
              <img class="intro_title" height="28" src="@/assets/img/taiko/world/intro_title_3.png" alt="">

              <div class="intro_subtitle">
                <span>挑战时间</span>
                <span class="dotted_line"></span>
              </div>
              <div class="intro_content">
                <div>区域赛结束后当日</div>
              </div>

              <div class="intro_subtitle">
                <span>挑战资格</span>
                <span class="dotted_line"></span>
              </div>
              <div class="intro_content">
                <div>区域赛冠军</div>
              </div>

              <div class="intro_subtitle">
                <span>挑战规则</span>
                <span class="dotted_line"></span>
              </div>
              <div class="intro_content">
                <div>区域赛的冠军玩家将继续游玩三首决赛阶段课题曲中未使用的一首，加上决赛阶段共计三首歌曲的合计分数作为总成绩</div>
              </div>

              <div class="intro_subtitle">
                <span>晋级规则</span>
                <span class="dotted_line"></span>
              </div>
              <div class="intro_content">
                <div>若区域赛冠军总成绩达到「全球排名」前29名，将作为“区域代表”获得「鼓众！世界冠军赛2024」的参赛资格</div>
              </div>

            </div>
            <div class="content_bg">
              <img class="intro_title" height="28" src="@/assets/img/taiko/world/intro_title_4.png" alt="">

              <div class="intro_subtitle">
                <div>关于使用的鼓棒</div>
                <span class="dotted_line"></span>
              </div>
              <div class="intro_content">
                <div>· 比赛仅可以使用机台附属的鼓棒，或「《太鼓之达人》官方鼓棒」任一，但不可以使用自行加工过的鼓棒</div>
                <div>· 禁止在产品为非原本状态的情況下游玩（如：将太鼓盖上布等）</div>
              </div>

              <div class="intro_subtitle">
                <div>致未成年玩家以及其监护人等法定代理人</div>
                <span class="dotted_line"></span>
              </div>
              <div class="intro_content">
                <div>· 公开组未限制参赛年龄，未成年人参赛须由法定代理人或监护人同意方可参加</div>
                <div>· 获得「区域赛」参赛资格的玩家需填写“预选赛代表表单”，未成年玩家需另外请法定代理人或监护人填写”同意书“并签名</div>
                <div>· 参赛时，请尽可能在法定代理人或监护人的陪同下前往</div>
                <div>· 仅因不得已的情况而无法在当下取得法定代理人同意时，可带回「同意书」，并于店铺预算赛结束后七天內交回给参赛店铺</div>
              </div>

              <div class="intro_subtitle">
                <div>关于弃赛，取消资格</div>
                <span class="dotted_line"></span>
              </div>
              <div class="intro_content">
                <div>· 若无法于比赛前进行签到，有可能视为弃权</div>
                <div>· 参赛者可重复报名店铺预选赛，但已获得“区域赛参赛凭证”的玩家不可再次参与</div>
                <div>· 若经发现违反规则，则有可能被取消资格</div>
                <div>· 若做出大力挥舞鼓棒等危险行为，或是妨碍对手演奏，有可能被取消资格</div>
                <div>· 若参赛者因个人原因放弃店铺代表权，之后将无法参与其他店家的预赛事后若发现重复参加，将取消资格</div>
                <div>· 无法遵守比赛规则或店铺负责人、比赛工作人员指示的玩家，有可能被取消资格</div>
              </div>

              <div class="intro_subtitle">
                <div>关于放弃“区域代表”的相关措施</div>
                <span class="dotted_line"></span>
              </div>
              <div class="intro_content">
                <div>· 为了让各区域能有玩家出战，若区域赛代表人因个人原因弃赛，将由该区域的第二名作为替补参赛</div>
                <div>· 若区域代表临近世界赛开始放弃资格，则将不会从该区域选出替补参与冠军赛</div>
                <div>· 即使区域代表放弃资格，也不会将区域代表替补的名称及成绩登记至「全球排名」</div>
                <div>· 若法遵守比赛规则或店铺负责人、比赛工作人员指示的玩家，有可能被取消资格</div>
              </div>

              <div class="intro_subtitle">
                <div>其他</div>
                <span class="dotted_line"></span>
              </div>
              <div class="intro_content">
                <div>· 若未按规则进行比赛，有可能根据店铺负责人的判断暂时中断比赛或进行重赛</div>
                <div>· 若发生机台故障等突发事故，有可能根据店铺负责人的判断暂时中断比赛或进行重赛</div>
                <div>·
                  参赛玩家默认同意本公司或第三方将玩家的肖像、姓名、玩家名称（鼓众广场内名称）、排名、游玩视频、采访留言等内容使用于商品、网站、其他信息媒体等的编辑、发布、公开、报导或运用（包含商业用途在内的一切用途）上
                </div>
                <div>· 参加店铺预选赛、区域赛时，前往各举办店家的交通费、住宿费以及其他支出均由参赛者负担</div>
                <div>· 参加「鼓众！世界冠军赛2024」时，前往比赛会场的交通费、住宿费由官方承担</div>
                <div>· 活动有可能未经预告进行内容变更、中止或延期</div>
                <div>· 本次活动最终解释权归属太鼓之达人赛事组委会所有</div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="content_main" v-else-if="page === 3">
        <div class="block">
          <div class="content_1">
            <div class="content_bg">
              <div class="intro_subtitle_2" @click="showQ('q1')">
                <div class="q">
                  <span>Q1.可以使用官方鼓棒吗</span>
                  <img v-if="q1" src="@/assets/img/taiko/world/down.png" width="14" alt="">
                  <img v-else src="@/assets/img/taiko/world/up.png" width="14" alt="">
                </div>
                <div class="dotted_line_2"></div>
              </div>
              <div class="intro_content_2" v-show="q1">
                <div>可以，比赛可以使用机台附属鼓棒或是「《太鼓之达人》官方鼓棒」任一，但不可以使用自行加工过的鼓棒。</div>
              </div>
              <div class="gray_q1" v-show="q1">
                <div class="gray_title">比赛对「《太鼓之达人》官方鼓棒」的确认事项</div>
                <div class="gray_content">
                  <div class="gray_line1">①是否附有原装腕带？</div>
                  <div class="gray_line1">②是否有《太鼓之达人》的烙印？</div>
                  <div class="gray_line1">
                    <div>③是否有缠好手胶？</div>
                    <div class="gray_line3">※請勿让手胶遮到烙印</div>
                    <div class="gray_line3">※请勿缠绕在比烙印更前端的部分</div>
                    <div class="gray_line3">※可多层缠绕手胶</div>
                  </div>
                  <div class="gray_line1">④鼓棒形状是否有明显不同？</div>
                  <div class="gray_line1">
                    <div>⑤是否有自行加工（如削割、使其变形、涂漆、添加突起物、缠上布料等）鼓棒的木材部分？</div>
                    <div class="gray_line3">※禁止使用会对木材造成不良影响的溶剂，以及会因震动而脱落的涂料</div>
                    <div class="gray_line3">※禁止为了改变鼓棒重量或平衡而粘贴贴纸的行为</div>
                    <div class="gray_line3">※可于手胶或腕带上写上名字</div>
                  </div>
                  <div class="gray_line1">上述确认事项如有任一未遵守，将无法使用官方鼓棒</div>
                  <div class="gray_line1">其他由比赛主办方判定有危险之物亦无法使用请使用机台附属的鼓棒</div>
                </div>
                <img src="@/assets/img/taiko/world/q1img.jpg" width="110" alt="">
              </div>

              <div class="intro_subtitle_2" @click="showQ('q2')">
                <div class="q">
                  <span>Q2.参赛是否有年龄限制</span>
                  <img v-if="q2" src="@/assets/img/taiko/world/down.png" width="14" alt="">
                  <img v-else src="@/assets/img/taiko/world/up.png" width="14" alt="">
                </div>
                <div class="dotted_line_2"></div>
              </div>
              <div class="intro_content_2" v-show="q2">
                <div>公开组未限制参赛年龄，未成年人参赛须由法定代理人或监护人同意方可参加</div>
              </div>

              <div class="intro_subtitle_2" @click="showQ('q3')">
                <div class="q">
                  <span>Q3.店铺预选赛可以多次参与吗</span>
                  <img v-if="q3" src="@/assets/img/taiko/world/down.png" width="14" alt="">
                  <img v-else src="@/assets/img/taiko/world/up.png" width="14" alt="">
                </div>
                <div class="dotted_line_2"></div>
              </div>
              <div class="intro_content_2" v-show="q3">
                <div>参赛者可重复报名店铺预选赛，但已获得区域赛参赛凭证的“店铺代表”不可再次参与</div>
                <div>此外，若参赛者因个人原因放弃“店铺代表”权，之后将无法参与其他店家的预赛事后若发现重复参加，将取消资格</div>
              </div>

              <div class="intro_subtitle_2" @click="showQ('q4')">
                <div class="q">
                  <span>Q4.当我在店铺预选赛获胜成为“店铺代表”，接下来该做什么</span>
                  <img v-if="q4" src="@/assets/img/taiko/world/down.png" width="14" alt="">
                  <img v-else src="@/assets/img/taiko/world/up.png" width="14" alt="">
                </div>
                <div class="dotted_line_2"></div>
              </div>
              <div class="intro_content_2" v-show="q4">
                <div>①阅读区域赛介绍，请在详细阅读后，于指定时间前往区域赛店铺参赛</div>
                <div>②填写“预选赛代表表单”，未成年玩家需另外请法定代理人或监护人填写”同意书“并签名；并于店铺预选赛结束后，七天内将表单交回参赛店铺</div>
                <div>③妥善保管区域赛参赛凭证，如参赛凭证遗失，将无法参加区域赛</div>
              </div>
              <div class="intro_subtitle_2" @click="showQ('q5')">
                <div class="q">
                  <span>Q5.当我在店铺预选赛获胜成为“店铺代表”,但因故无法前往比赛，我可以请朋友代为参加吗</span>
                  <img v-if="q5" src="@/assets/img/taiko/world/down.png" width="14" alt="">
                  <img v-else src="@/assets/img/taiko/world/up.png" width="14" alt="">
                </div>
                <div class="dotted_line_2"></div>
              </div>
              <div class="intro_content_2" v-show="q5">
                <div>无论哪个组别均不可由报名者本人以外的人代打一经发现，双方都将被取消资格</div>
              </div>

              <div class="intro_subtitle_2" @click="showQ('q6')">
                <div class="q">
                  <span>Q6.当我进入了全球排名29名以內，缺因故无法参加「鼓众！世界冠军赛2024」时，我该怎么办</span>
                  <img v-if="q6" src="@/assets/img/taiko/world/down.png" width="14" alt="">
                  <img v-else src="@/assets/img/taiko/world/up.png" width="14" alt="">
                </div>
                <div class="dotted_line_2"></div>
              </div>
              <div class="intro_content_2" v-show="q6">
                <div>请先联系官方表明放弃资格，为了让各区域能有玩家出战，若区域赛代表人因个人原因弃赛，将由该区域的第二名作为替补参赛</div>
                <div>若区域代表临近世界赛开始放弃资格，则将不会从该区域选出替补参与冠军赛</div>
                <div>即使区域代表放弃资格，也不会将区域代表替补的名称及成绩登记至「全球排名」</div>
              </div>

              <div class="intro_subtitle_2" @click="showQ('q7')">
                <div class="q">
                  <span>Q7.在比赛中，若排名靠前的玩家成绩相同时将如何应对？</span>
                  <img v-if="q7" src="@/assets/img/taiko/world/down.png" width="14" alt="">
                  <img v-else src="@/assets/img/taiko/world/up.png" width="14" alt="">
                </div>
                <div class="dotted_line_2"></div>
              </div>
              <div class="intro_content_2" v-show="q7">
                <div>店铺预选赛中，会有工作人员从三首课题曲中未使用的两首歌曲里指定一首来进行附加赛，若附加赛仍为相同成绩，则会再使用剩余一首歌曲进行附加赛</div>
                <div>区域赛决赛阶段中，会采用决赛回合专用课题曲中未使用的剩余一首来进行附加赛，并依据一首歌曲的合计成绩来决定区域大会冠军其三首乐曲的合计成绩将登记至「全球排名」</div>
              </div>

              <div class="intro_subtitle_2" @click="showQ('q8')">
                <div class="q">
                  <span>Q8.未成年需要有监护人陪同吗？</span>
                  <img v-if="q8" src="@/assets/img/taiko/world/down.png" width="14" alt="">
                  <img v-else src="@/assets/img/taiko/world/up.png" width="14" alt="">
                </div>
                <div class="dotted_line_2"></div>
              </div>
              <div class="intro_content_2" v-show="q8">
                <div>获得「区域赛」参赛资格的未成年玩家需另外请法定代理人或监护人填写”同意书“并签名</div>
                <div>参赛时，请尽可能在法定代理人或监护人的陪同下前往</div>
                <div>仅因不得已的情况而无法在当下取得法定代理人同意时，可带回「同意书」，并于店铺预算赛结束后七天內交回给参赛店铺</div>
              </div>

              <div class="intro_subtitle_2" @click="showQ('q9')">
                <div class="q">
                  <span>Q9.可以现场观赛吗？</span>
                  <img v-if="q9" src="@/assets/img/taiko/world/down.png" width="14" alt="">
                  <img v-else src="@/assets/img/taiko/world/up.png" width="14" alt="">
                </div>
                <div class="dotted_line_2"></div>
              </div>
              <div class="intro_content_2" v-show="q9">
                <div>可以，请在工作人员的指引下文明观赛</div>
              </div>

              <div class="intro_subtitle_2" @click="showQ('q10')">
                <div class="q">
                  <span>Q10.参加比赛时的交通费和住宿费该怎么办？</span>
                  <img v-if="q10" src="@/assets/img/taiko/world/down.png" width="14" alt="">
                  <img v-else src="@/assets/img/taiko/world/up.png" width="14" alt="">
                </div>
                <div class="dotted_line_2"></div>
              </div>
              <div class="intro_content_2" v-show="q10">
                <div>参加店铺预选赛、区域赛时，前往各举办店家的交通费、住宿费以及其他支出均由参赛者负担</div>
                <div>参加「鼓众！世界冠军赛2024」时，前往比赛会场的交通费、住宿费由官方承担</div>
              </div>

              <div class="intro_subtitle_2" @click="showQ('q11')">
                <div class="q">
                  <span>Q11.可以修改演奏设置吗？</span>
                  <img v-if="q11" src="@/assets/img/taiko/world/down.png" width="14" alt="">
                  <img v-else src="@/assets/img/taiko/world/up.png" width="14" alt="">
                </div>
                <div v-show="q11" class="dotted_line_2"></div>
              </div>
              <div class="intro_content_2" v-show="q11">
                <div>比赛中，玩家仅可以调整演奏设置中的「音符位置调整」和「声音」，其余选项均为「预设值」</div>
              </div>

            </div>


          </div>
        </div>
        <div class="block">
          <div class="stars"></div>
        </div>
      </div>
      <div class="content_main" v-else-if="page === 4">
        <div class="block">
          <div class="content_1 content_2">
            <div class="content_bg">
              <img class="content_address_preview" src="@/assets/img/taiko/world/game_area_address_preview.png" alt="">
              <div class="area">
                <div v-for="(group, index) in gameAreaStoreData" :key="index" class="area_block">
                  <div class="area_tag" :class="{ area_tag_2: area[index] }" @click="showArea(index)">
                    <div class="area_title">{{ group.area }}</div>
                    <div class="area_icon">
                      <img width="18" v-if="area[index]" src="@/assets/img/taiko/world/minus.png" alt="">
                      <img width="18" v-else src="@/assets/img/taiko/world/plus.png" alt="">
                    </div>
                  </div>
                  <div class="area_content" v-if="area[index]">
                    <div class="area_detail" v-for="(storeInfo, storeIndex) in gameAreaStoreData[index].items"
                      :key="storeIndex">
                      <div class="area_store">{{ storeInfo.sotre }}</div>
                      <div class="area_time">举办时间：{{ storeInfo.time }}</div>
                      <div class="area_adress">地 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 址：{{ storeInfo.address }} </div>
                      <div class="dotted_line_3"></div>
                    </div>
                  </div>
                </div>
              </div>
              <img class="content_address_preview" src="@/assets/img/taiko/world/game_address_preview.png" alt="">
              <div class="area">
                <div v-for="(group, index) in gameStoreData" :key="index" class="area_block">
                  <div class="area_tag" :class="{ area_tag_2: area2[index] }" @click="showArea2(index)">
                    <div class="area_title">{{ group.area }}</div>
                    <div class="area_icon">
                      <img width="18" v-if="area2[index]" src="@/assets/img/taiko/world/minus.png" alt="">
                      <img width="18" v-else src="@/assets/img/taiko/world/plus.png" alt="">
                    </div>
                  </div>
                  <div class="area_content" v-if="area2[index]">
                    <div class="area_detail" v-for="(storeInfo, storeIndex) in gameStoreData[index].items"
                      :key="storeIndex">
                      <div class="area_store">{{ storeInfo.sotre }}</div>
                      <div class="area_time">举办时间：{{ storeInfo.time }}</div>
                      <div class="area_adress">地 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 址：{{ storeInfo.address }} </div>
                      <div class="dotted_line_3"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="block">
          <div class="stars"></div>
        </div>
      </div>
      <div class="footer">
        <div class="stars"></div>
        <img class="back" @click="scrollToTop" src="@/assets/img/taiko/guide/footer_back.png" alt="" />
        <div class="bg">
          <img src="@/assets/img/taiko/guide/footer_bg.png" alt="" />
          <img src="@/assets/img/taiko/guide/footer_logo.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gameAllStore from "@/assets/data/game_store.json"
import gameAreaStore from "@/assets/data/game_area_store.json"
export default {
  name: "championship",
  data() {
    return {
      scrollTop: 0,
      page: 2,
      q1: true,
      q2: true,
      q3: true,
      q4: true,
      q5: true,
      q6: true,
      q7: true,
      q8: true,
      q9: true,
      q10: true,
      q11: true,
      area: [true, true, true, true, true],
      area2: [true, true, true, true, true],
      gameStoreData: [],
      gameAreaStoreData: [],
    };
  },

  mounted() {
    this.gameStoreData = this.groupByArea(gameAllStore)
    this.gameAreaStoreData = this.groupByArea(gameAreaStore)
    // console.log(this.gameStoreData)
    // console.log(this.gameAreaStoreData)
    //获取url传参的page的参数
    // let type = this.$route.query.type;
    // console.log(type);
    // if (Number(type) === 1) {
    //   this.page = 6;
    // }
    //监听滚动的Y轴并log返回Y轴的值
    const element = document.getElementById("championship");
    element.addEventListener("scroll", this.getHeight);
  },
  beforeDestroy() {
    const element = document.getElementById("championship");
    element.removeEventListener("scroll", this.getHeight);
  },
  methods: {
    showQ(numQ) {
      this[numQ] = !this[numQ]
    },
    showArea(index) {
      // console.log(this.area[index])
      this.area[index] = !this.area[index]
      this.area = Object.assign({}, {
        ...this.area
      })
    },
    showArea2(index) {
      // console.log(this.area2[index])
      this.area2[index] = !this.area2[index]
      this.area2 = Object.assign({}, {
        ...this.area2
      })
    },
    groupByArea(arr) {
      const result = [];
      let currentGroup = { area: "", items: [] };

      arr.forEach(item => {
        if (item.area === currentGroup.area) {
          currentGroup.items.push(item);
        } else {
          if (currentGroup.area) {
            result.push(currentGroup);
          }
          currentGroup = { area: item.area, items: [item] };
        }
      });

      if (currentGroup.area) {
        result.push(currentGroup);
      }

      return result;
    },
    getHeight() {
      const element = document.getElementById("championship");
      let scrollTop = element.scrollTop;
      this.scrollTop = scrollTop;
      // console.log(scrollTop);
      // if(this.page<5){
      //   if(scrollTop<=360){
      //     if(this.page>2 && this.page<5){
      //       this.page = 3;
      //     }else{
      //       this.page = 1;
      //     }
      //   }
      // }
    },
    notOpen() {
      this.$toast({
        content: "暂未开放",
        duration: 1500
      });
    },
    scrollToSomeY(page, point) {
      this.page = page;
      // console.log('someY',point)
      let timer = setInterval(() => {
        const element = document.getElementById("championship");
        let ispeed = Math.floor((point - element.scrollTop) / 30);
        element.scrollBy(this.scrollTop, this.scrollTop + ispeed);
        if (element.scrollTop >= point) {
          element.scrollTop = point;
          clearInterval(timer);
        }
      }, 22);
    },
    scrollToTop() {
      // console.log('back')
      let timer = setInterval(() => {
        const element = document.getElementById("championship");
        let ispeed = Math.floor(this.scrollTop / 6);
        element.scrollTop = this.scrollTop - ispeed;
        if (element.scrollTop <= 6) {
          // element.scrollTop === 0;
          clearInterval(timer);
        }
      }, 22);
    },
  },
};
</script>

<style lang='scss' scoped>
@import "assets/scss/index.scss";
@import "./index.scss";
</style>